import { useEffect, useState } from "react";
import { ModuleProps } from "components/props/ModuleProps";

interface DashboardItemOnlineProps {
    children: any;
    module: ModuleProps;
}
export const DashboardItemOnline = ({ children, module }: DashboardItemOnlineProps) => {

    const [show, setShow] = useState(false);
    
    useEffect(() => {

        const handleOnOffline = () => {
            setShow((module.onlineOnly && navigator.onLine) || !module.onlineOnly);
        }

        window.addEventListener("offline", handleOnOffline);
        window.addEventListener("online", handleOnOffline);

        handleOnOffline();

        return function cleanupEventListeners() {
            window.removeEventListener("offline", handleOnOffline);
            window.removeEventListener("online", handleOnOffline);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); 

    return (
        show &&
        children
    )
}
